import { writable, type Writable } from 'svelte/store';

/**
 * The old layout toggle has been removed from Experimental features (Labs), so
 * the new layout is now the standard, always-on experience.
 */
export const showNewLayout: Writable<boolean> = writable<boolean>(true);

/**
 * Controls the New App Layout onboarding modal. Set once on app load for users
 * who haven't seen it (see MainLayoutNew), and exposed as a store so the Dev
 * modal can re-open it on demand for testing.
 */
export const showNewLayoutOnboarding: Writable<boolean> = writable<boolean>(false);
